<div class="chatter-message"
     *ngIf="message"
     [ngClass]="{'after-dom-inserted': domInserted}">
    <div class="chatter-message__container" [ngClass]="{
        'chatter-message__user': origin === 'USER',
        'chatter-message__system': origin === 'SYSTEM'}">
        <p>{{message}}</p>
    </div>
</div>
